import { render, staticRenderFns } from "./Collections.vue?vue&type=template&id=ee5e27c8&scoped=true&"
import script from "./Collections.vue?vue&type=script&lang=ts&"
export * from "./Collections.vue?vue&type=script&lang=ts&"
import style0 from "./Collections.vue?vue&type=style&index=0&id=ee5e27c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5e27c8",
  null
  
)

export default component.exports